<template>
    <v-dialog v-model="dialog" max-width="770" :fullscreen="isPhone" scrollable>
        <template v-slot:activator="{ props }">
            <v-list-item v-bind="props">
                <template v-slot:prepend>
                    <v-icon> mdi-swap-horizontal </v-icon>
                </template>
                <v-list-item-title>
                    {{ t("change_company") }}
                </v-list-item-title>
            </v-list-item>
        </template>
        <v-card :loading="loading ? 'accent' : false">
            <!-- The dialog is scrollable: only the v-card-text scrolls, the header stays. -->
            <div class="d-flex align-center pl-4 pr-2 py-2">
                <span class="text-h6 font-weight-bold">{{ t("change_company") }}</span>
                <v-spacer />
                <v-btn icon="mdi-close" variant="text" :aria-label="t('close')" @click="dialog = false" />
            </div>
            <v-divider />
            <v-card-text>
                <v-alert variant="outlined" type="error" density="compact" class="mb-3">
                    RESTRICTED FEATURE FOR PRODUUZ.IT STAFF
                </v-alert>
                <v-skeleton-loader v-if="companies.length == 0 && loading" type="list-item-avatar-three-line@2">
                </v-skeleton-loader>
                <div v-else class="company-grid" :class="{ phone: isPhone }">
                    <v-card v-for="company in companies" :key="company.uuid" @click="change_company(company.uuid)"
                        border :color="selected_company == company.uuid ? 'accent' : ''">
                        <div class="company-logo">
                            <v-img v-if="company.logo_url" contain :src="company.logo_url" />
                            <v-icon v-else size="40"> mdi-factory </v-icon>
                        </div>
                        <div class="text-body-2 px-2 pb-2">
                            <div class="company-name">{{ company.name }}</div>
                        </div>
                    </v-card>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
// import _ from "lodash"
import { backend_api_v2 } from "/src/utils/apiv2"
import { nameSort } from "/src/utils/basics.js";
// import bus from "/src/utils/event_bus"
import { useAppStore } from "@/stores/app";
import { useSessionStore } from "@/stores/session";
import { useTranslationsStore } from "@/stores/translations";
import { useIsPhone } from "@/composables/display";

export default {
    setup() {
        const app_store = useAppStore()
        const session_store = useSessionStore()
        const translations_store = useTranslationsStore()
        const t = translations_store.translate
        return {
            app_store,
            session_store,
            t,
            ...useIsPhone(),
        }
    },
    data: () => ({
        loading: false,
        dialog: false,
        companies: [],
    }),
    computed: {
        selected_company() {
            return this.session_store.user_object?.auth?.company?.uuid
        }
    },
    methods: {
        change_company(company) {
            this.loading = true
            backend_api_v2
                .post("/staff/set_my_company/", { company })
                .then(() => {
                    this.dialog = false
                    this.loading = false
                    this.app_store.initialLoad()
                    this.app_store.refreshBaseUserData(false)
                })
        },
    },
    watch: {
        dialog(d) {
            if (d) {
                this.loading = true
                backend_api_v2
                    .get("/staff/companies/")
                    .then(({ data }) => this.companies = data.sort((a, b) => nameSort(a.name, b.name)))
                    .then(() => {
                        this.loading = false
                    })
            } else {
                this.$emit("close")
            }
        },
    },
}
</script>

<style scoped>
.company-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
}

.company-grid.phone {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.company-logo {
    height: 80px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.company-grid.phone .company-logo {
    height: 64px;
}

.company-logo .v-img {
    height: 100%;
}

/* Two lines instead of one truncated line: long names stay readable without a hover tooltip. */
.company-name {
    text-align: center;
    line-height: 1.25;
    min-height: calc(2 * 1.25em);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    overflow-wrap: anywhere;
}
</style>